module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/studio-suns_access_02-43dce45d9c7b710e51a58188fdaa867c.jpg";